/* eslint-disable camelcase */
import React from "react";
import { useAppState } from "hooks/AppContext";
import { CulturesNav } from "./CulturesNav";
import { BrokenImageIcon } from "./Icons";
import styles from "./Hero.module.scss";

const getPilboxUrl = (imageUrl: string, imageWidth: number, imageHeight?: number, fill?: boolean): string => {
    const pilboxUrl = "https://pilbox.themuse.com/";
    const imageUrlRegex = /^https?:\/\//;
    const mode = fill ? "mode=fill&background=ccc" : "mode=crop";
    const suffix = `filter=antialias&opt=1&${mode}&pos=top&prog=1&q=keep`;
    const height = imageHeight ? `&h=${imageHeight}` : "";
    const width = imageWidth ? `&w=${imageWidth}` : "";

    if (imageUrlRegex.test(imageUrl)) {
        return `${pilboxUrl}?url=${imageUrl}${height}${width}&${suffix}`;
    }

    return "";
};

// We add the priority this way because typescript is not yet up to speed, without modifying the build in props.
const extraProps = {
    fetchpriority: "high"
};

const CompanyHeroImage = (props: { url: string; }) => {
    // eslint-disable-next-line max-len
    const backup = "https://assets.themuse.com/images/missing-company-hero.jpg";
    const { url = backup } = props;
    return (
        <picture className={styles.picture}>
            <source media="(min-width: 1040px)" srcSet={getPilboxUrl(url, 1040, 375)} />
            <source media="(min-width: 992px)" srcSet={getPilboxUrl(url, 992, 375)} />
            <source media="(min-width: 768px)" srcSet={getPilboxUrl(url, 768, 244)} />
            <source media="(max-width: 375px)" srcSet={getPilboxUrl(url, 375, 244)} />
            <img
                src={getPilboxUrl(url || backup, 375, 244)}
                alt=""
                className={styles.heroImage}
                width="375"
                height="244"
                {...extraProps}
            />
        </picture>
    );
};

const CompanyLogo = (props: { url: string }) => {
    const { url } = props;
    return (
        <img
            data-testid="logo"
            src={url}
            alt=""
            className={styles.logo}
            aria-hidden="true"
            width="128"
            height="128"
            {...extraProps}
        />
    );
};

const Hero = () => {
    const { company } = useAppState();
    const {
        snapshot_photo,
        logo,
        name
    } = company;

    return (
        <div className={styles.hero}>
            <div className={styles.heroGrid}>
                <div className={styles.heroImageWrapper}>
                    <CompanyHeroImage {...{ url: snapshot_photo }} />
                </div>
                <div className={styles.heroContentWrapper}>
                    <div className={styles.logoWrapper}>
                        {logo ? <CompanyLogo {...{ url: logo }} /> : <BrokenImageIcon className={styles.missingLogo} />}
                    </div>
                    <h1 className={styles.title}>{name}</h1>
                    <CulturesNav />
                </div>
            </div>
        </div>
    );
};
Hero.displayName = "Hero";

export { Hero };
